import { render, staticRenderFns } from "./ButtonInvitationNotification.vue?vue&type=template&id=de081070&scoped=true"
import script from "./ButtonInvitationNotification.vue?vue&type=script&lang=js"
export * from "./ButtonInvitationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de081070",
  null
  
)

export default component.exports